import React, { ReactNode, MouseEvent } from 'react';
import { IconButton, Tooltip } from '@mui/material';
import classNames from 'classnames';

import classes from './MenuButton.module.scss';

type MenuButtonProps = {
  tooltip: string;
  isActive: boolean;
  icon: ReactNode;
  onClick: (event: MouseEvent<HTMLButtonElement>) => void;
};

export const MenuButton = ({ tooltip, isActive, icon, onClick }: MenuButtonProps) => {
  const className = classNames(classes.menuButton, { [classes.active]: isActive });

  return (
    <Tooltip title={tooltip}>
      <IconButton className={className} size="small" onClick={onClick}>
        {icon}
      </IconButton>
    </Tooltip>
  );
};
